import React, { useEffect } from "react";
import $ from "jquery";
import Header from "../../components/new-dashboard/header";
import LeftMenu from "../../components/new-dashboard/left-menu";

const Index = ({ children, sub = false}) => {
  useEffect(() => {
    const script = `
            new HSGoTo('.js-go-to');
            new HSHeader('#header').init();
            new HSMegaMenu('.js-mega-menu', {"desktop": {"position": "left"}});
        `;

    $("body").append(`<script className="homescript">${script}</script>`);

    return () => {
      $(".homescript").remove();
    };
  }, []);

  // use path to define title page
  const path = window.location.pathname;
  let titlePage = "Dashboard";
  if (path.includes("product_managment/list")) {
    titlePage = "Products";
  } else if (path.includes("product_managment/add")) {
    titlePage = "Add Product";
  }

  return (
    <div className="navbar-sidebar-aside-lg" style={{ background: "#f1f1f1" }}>
      <Header></Header>
      <main id="content" role="main" className=" text-black">
        <LeftMenu sub = {sub}  ></LeftMenu>

        <div className="navbar-sidebar-aside-content content-space-1 content-space-md-2 px-lg-5 px-xl-10">
          <div className="mt-md-6">
            <h1>{titlePage}</h1>
            {children}
          </div>
        </div>
      </main>
    </div>
  );
};

export default Index;
